module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v(" PRAISE FOR NINA KIRIKI HOFFMAN")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_vm._v("“A gifted and enigmatic author … Is Nina Hoffman a genius? Oh, yes. Yes, indeed.” —"), _c('i', [_vm._v("Fantasy & Science Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_vm._v("“One of a kind, an American original … one of the finest writers working the blurry edge of fantasy and horror.” —"), _c('i', [_vm._v("Locus")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_c('i', [_vm._v("The Thread That Binds the Bones")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("Winner of the Bram Stoker Award for Best First Novel")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_vm._v("“A good story by a fine writer … High quality and mesmeric appeal.” —Roger Zelazny")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_vm._v("“A joy to read … beautifully written and unique in its freshness of vision … What a delightful addition to the family of fantasists [Nina Hoffman] is.” —Kate Wilhelm, author of "), _c('i', [_vm._v("Where Late the Sweet Birds Sang")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise.vue
// module id = 63
// module chunks = 0